import styles from '@/styles/addressForm.module.scss'
import { Button, Form, Input, Space, Select, message } from 'antd';
import { useState, useEffect } from 'react';
import CloseIcon from '@/svgs/close-hover.svg'
import myAccountApi from '@/service/modules/myAccountApi'
import SuburbSelect from './SuburbSelect';

interface Address {
  address: string,
  address1: string,
  addressID: number,
  firstName: string,
  lastName: string,
  phone: string,
  postCode: string,
  suburb: string,
  suburbID: string | number,
  city: string
}

interface AddressFormProps {
  address: Address | null
  success: any
  cancel: any
}

export default function AddressForm({ address, success, cancel }: AddressFormProps) {
  const [form] = Form.useForm();

  const [isEdit, setIsEdit] = useState(false);



  useEffect(() => {
    setIsEdit(!!(address?.addressID))
    if (address?.addressID) {
      form.setFieldsValue(address)
    } else {
      form.resetFields()
    }
  }, [address]);

  // 校验成功，发起提交请求
  const onFinish = (values: any) => {
    console.log('Success:', values)

    saveAddress(values)
  }

  // 提交新增/编辑地址
  const saveAddress = async (values: any) => {
    try {
      const dataObj: any = {
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        address: values.address,
        address1: values.address1,
        suburb: values.suburb,
        suburbID: values.suburbID,
        city: values.city,
        postCode: values.postCode
      }

      // 判断新增还是编辑地址
      if (isEdit) dataObj.addressID = address?.addressID
      const params = isEdit ? myAccountApi.editAddresses : myAccountApi.addAddresses

      let res = await params(dataObj)
      if (res.data) {
        message.success('Success')
        success()
      }
    } catch (error: any) {
      message.error(error.message)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // 只允许输入数字（0-9）
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const suburbChange = (_: any, option: any) => {
    option.name && form.setFieldsValue({ suburb: option.name })
  }

  return (
    <div className={styles['address-form']}>
      <div className={styles['close-box']}>
        <CloseIcon className={styles['close-icon']} onClick={cancel} />
      </div>

      <Form
        name="basic"
        layout="vertical"
        size={'large'}
        style={{ width: '100%' }}
        form={form}
        initialValues={{}}
        onFinish={onFinish}
        autoComplete="off"
        scrollToFirstError
      >

        <div className={styles['form-box']}>
          <div className={styles['box-item']}>
            <Form.Item
              label="Recipient Name"
              rules={[{ required: true }]}
              style={{ marginBottom: 0 }}
              required
            >
              <Space size={16}>
                <Form.Item
                  label=""
                  name="firstName"
                  rules={[
                    {
                      validator(_, value) {
                        const myLastname = form.getFieldValue('lastName')
                        console.log(value);
                        console.log(myLastname);

                        if (!value || !myLastname) {
                          return Promise.reject(new Error(`Please enter a value between 2 and 100 characters long.`));
                        } else if (value.length < 2 || myLastname.length < 2) {
                          return Promise.reject(new Error(`Please enter a value between 2 and 100 characters long.`));
                        } else if (value.length > 100) {
                          return Promise.reject(new Error(`The First Name length is no more than 100 characters.`));
                        } else if (myLastname.length > 100) {
                          return Promise.reject(new Error(`The Last Name length is no more than 100 characters.`));
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  style={{ display: 'block' }}
                >
                  <Input maxLength={60} placeholder="First Name" />
                </Form.Item>
                <Form.Item
                  label=""
                  name="lastName"
                  style={{ display: 'block' }}
                // rules={[
                //   { required: true, message: `'Last Name' is required` },
                //   {
                //     validator(_, value) {
                //       if (value && value.length < 2) {
                //         return Promise.reject(new Error(`'Last Name' is required`));
                //       }
                //       return Promise.resolve()
                //     },
                //   },
                // ]}
                >
                  <Input maxLength={60} placeholder="Last Name" onChange={() => { form.validateFields(['firstName']); }} />
                </Form.Item>
              </Space>
            </Form.Item>

            <div className={styles['post-code']}>
              <div className={styles['post-code-item']}>
                <div style={{ display: 'none' }}>
                  <Form.Item
                    name="suburb"
                    rules={[{ required: true, message: `Surburb is required.` }]}
                  >
                    <Input />
                  </Form.Item>
                </div>
                <Form.Item
                  label="Suburb"
                  name="suburbID"
                  rules={[{ required: true, message: `Surburb is required.` }]}
                >
                  <SuburbSelect placeholder="Surburb" onChange={suburbChange} />
                </Form.Item>
              </div>
              <div className={styles['post-code-item']}>
                <Form.Item
                  label="Postcode"
                  name="postCode"
                  rules={[{ required: true, message: `Postcode is required.` },]}
                >
                  <Input maxLength={4} style={{ width: '100%' }} onKeyPress={handleKeyPress} />
                </Form.Item>
              </div>
            </div>

            <Form.Item
              label="Street Address"
              name="address"
              rules={[{ required: true, message: `Address Line is required.` },]}
            >
              <Input maxLength={200} style={{ width: '100%' }} />
            </Form.Item>
          </div>

          <div className={styles['box-item']}>
            <Form.Item
              label={<div>Phone Number <span style={{ fontSize: 12 }}>(e.g. 0212345678 no symbol + - No space)</span></div>}
              name="phone"
              rules={[
                { required: true, message: `Phone/Mobile is required.` },
                {
                  validator(_, value) {
                    if (value && !value.match(/^[0-9]+$/)) {
                      return Promise.reject(new Error('Numbers only'));
                    }
                    //  else if (value && value.length != 10) {
                    //   return Promise.reject(new Error('Your phone number should be 10 characters long.'));
                    // } else if (value && !value.match(/^[0][234578][0-9]{8}$/)) {
                    //   return Promise.reject(new Error('Invalid phone number.'));
                    // }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              <Input type="tel" maxLength={10} placeholder="For delivery use only" />
            </Form.Item>

            <div className={styles['post-code']}>
              <div className={styles['post-code-item']}>
                <Form.Item
                  label="City"
                  name="city"
                  rules={[{ required: true, message: `City is required.` },]}
                >
                  <Input style={{ width: '100%' }} />
                </Form.Item>
              </div>
              <div className={styles['post-code-item']}>
                <Form.Item label="Country" name="country">
                  <Input placeholder="New Zealand" disabled />
                </Form.Item>
              </div>
            </div>

            <Form.Item
              label="Address line 2 (optional)"
              name="address1"
            >
              <Input maxLength={200} />
            </Form.Item>
          </div>
        </div>


        {/* 提交按钮 */}
        <Form.Item>
          <div className={styles['btn-box']}>
            <Button className={styles['cancel-btn']} onClick={cancel}>
              Cancel
            </Button>
            <Button className={styles['save-btn']} htmlType="submit">
              Save to Address Book
            </Button>
          </div>
        </Form.Item>
      </Form>

    </div>
  )
}
